<template>
  <div class="centerBox">
    <!-- 筛选框 -->
    <div class="InsuranceSelect">
      <el-row>
        <el-col :span="4" :offset="0">
          <el-select
            style="margin-right: 10px"
            v-model="orderStatus"
            placeholder="请选择投保意向单状态"
            size="medium"
            clearable
            @change="selInLists"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option> </el-select
        ></el-col>
        <el-col :span="14" :offset="0">
          <el-select
            v-model="cropChoose"
            placeholder="请选择品种"
            size="medium"
            clearable
            @change="selInLists"
          >
            <el-option
              v-for="item in tabBarLeftAllVarieties"
              :key="item.id"
              :label="item.value"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="2" :offset="3">
          <el-button
            type="primary"
            size="small"
            @click="buyInsure"
            class="button14"
            >申请投保</el-button
          >
        </el-col>
      </el-row>
      <!-- 分割线 -->
      <el-divider></el-divider>
    </div>

    <!-- 表格 列表组件      有操作按钮 -->
    <table-order-list
      class="tablelist"
      :isShow="isShow"
      @alginGet="alginGet"
      ref="tabList"
      :list="list"
      :loading="loading"
    />

    <pagiation
      :total="total"
      :pageSize="pageSize"
      :pageNo="pageNo"
      @currentChange="currentChange"
      :pagisShow="isShow"
      v-if="isShow"
    />

    <!-- 浮窗 -->
    <fu-box />
  </div>
</template>

<script>
import Pagiation from "@/components/Pagiation.vue";
import FuBox from "../compoments/ruralBox.vue";
import TableOrderList from "./TableOrderList.vue";
import sameIn from "@/mixins/ruralListsdetails.js";
import { SessionStorage } from "@/utils/storage";

import { ruralInsurance } from "@/api/request/snkd.produce";

export default {
  components: { TableOrderList, FuBox, Pagiation },
  name: "OrderList",
  mixins: [sameIn],

  data() {
    return {
      // 搜索是否有数据  分页是否显示 --  true 显示列表 false显示无数据
      isShow: true,
      loading: true,
      // 订单状态
      options: [
        { label: "全部状态", value: -1 },
        { label: "已提交", value: 1 },
        { label: "已完成", value: 2 },
      ],
      tabBarLeftAllVarieties: [
        { value: "全部作物", id: "" },
        { value: "南粳46", id: 4 },
        { value: "太安1号", id: 6 },
        // { value: "南粳9108", id: 5 },
        // { value: "松香粳1018", id: 2 },
        // { value: "沪软1212", id: 1 },
        // { value: "银香38", id: 3 },
      ],
      cropChoose: null,
      orderStatus: SessionStorage.get("ruralSeleorderStatus") || "",

      // 列表数据
      list: [],
    };
  },
  watch: {
    orderStatus(val) {
      SessionStorage.set("ruralSeleorderStatus", val);
    },
  },
  created() {
    this.getInLists();
  },
  methods: {
    // 筛选
    selInLists() {
      this.pageNo = 1;
      this.getInLists();
    },
    // 获取订单列表
    async getInLists() {
      this.loading = true;
      const { respCode, obj } = await ruralInsurance.getInsureOrderListSummary({
        companyId: this.companyId,
        farmId: this.farmId,
        // companyId: 13053,
        // farmId: 14708,
        insureId: 2, // 险种id: 1-蔬菜险 | 2-穗优险 ,
        orderStatus: this.orderStatus === -1 ? "" : this.orderStatus,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        grainType: this.cropChoose,
      });
      if (respCode === 0) {
        this.list = obj.list;
        this.total = obj.totalCount;
        if (this.list.length) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.centerBox {
  background-color: #fff;
  .tablelist {
    padding: 0 30px 30px 30px;
    min-height: calc(100vh - 360px);
    overflow: hidden;
  }
}

::v-deep .el-table {
  height: 100%;

  .el-table__body-wrapper {
    overflow: hidden;
    position: relative;
    height: calc(100% - 80px);
  }
}

.InsuranceSelect {
  padding: 30px 30px 0;
}
.el-button {
  width: 92px;
  height: 40px;
}

.timeSection {
  width: 390px;
}
.el-select {
  height: 40px;
}
::v-deep .el-input--medium .el-input__inner {
  height: 40px;
}
</style>
